import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { QueryStatus } from '@reduxjs/toolkit/query';

import { theme } from 'antd';

import {
	EWithdrawalStatuses,
	transactionApi,
	useAddWithdrawalMutation,
	useGetWithdrawalQuery,
} from 'entities/Transaction';
import { useGetAppConfigQuery } from 'shared/api/commonApi';
import { useCommonSlice, useMedia } from 'shared/hooks';
import { EApiTags } from 'shared/typings';

import { TRANSACTION_STATUS_POLLING_INTERVAL } from '../consts';

export const useBalance = () => {
	const { t } = useTranslation();
	const isMd = useMedia();
	const dispatch = useDispatch();
	const interval = useRef<ReturnType<typeof setInterval> | undefined>(undefined);
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const { data: appConfig } = useGetAppConfigQuery();
	const { currenciesMap } = useCommonSlice();
	const { token } = theme.useToken();

	const [addWithdrawal, { isLoading, status: createdStatus, data: createdWithdrawal }] = useAddWithdrawalMutation();

	const { data: checkedWithdrawal } = useGetWithdrawalQuery(createdWithdrawal?.uuid, {
		skip: !createdWithdrawal?.uuid || !modalIsOpen,
	});

	useEffect(() => {
		if (createdStatus === QueryStatus.fulfilled) {
			setModalIsOpen(true);

			interval.current = setInterval(() => {
				dispatch(transactionApi.util.invalidateTags([EApiTags.SINGLE_TRANSACTION]));
			}, TRANSACTION_STATUS_POLLING_INTERVAL);
		}
	}, [createdStatus, dispatch]);

	useEffect(() => {
		if (
			!modalIsOpen ||
			checkedWithdrawal?.status === EWithdrawalStatuses.SUCCESS ||
			checkedWithdrawal?.status === EWithdrawalStatuses.FAILED
		) {
			clearInterval(interval.current);
			dispatch(transactionApi.util.invalidateTags([EApiTags.TRANSACTIONS_LIST]));
		}
	}, [modalIsOpen, checkedWithdrawal?.status, dispatch]);

	return {
		t,
		token,
		isMd,
		modalIsOpen,
		appConfig,
		currenciesMap,
		addWithdrawal,
		isLoading,
		checkedWithdrawal,
		setModalIsOpen,
	};
};
